import React, {useState, useEffect, useCallback} from "react";
import useAppContext from "../../../utils/Reducers";
import {useAxiosWithAuthorization} from "../../../utils/api";
import SelectBox from "../../../components/SelectBox";
import {isFieldDisabled} from "../../../utils/validators";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import {useId} from "react-id-generator";
import {ModalReturnListPop} from "../../Popup/ReturnListPop";

const InspectionReg = (props) => {
    const {
        store: {userInfo},
    } = useAppContext();

    //공통코드 검색 URL
    const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
    const [, fetchData] = useAxiosWithAuthorization(
        {
            url: SEARCH_CODE_URL,
        },
        {manual: true}
    );

    //추가, 수정일때 항목의 disabled 결정
    const disabledFields = {
        created: [""],
        updated: ["systemCd"],
    };

    const [loading, setLoading] = useState(false);

    const handleChangeField = useCallback((event) => {
        console.log(props.fieldValues);

        const {name, value} = event.target;
        if (name === "scrapAreaCd") {
            var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
            props.setFieldValues({
                ...props.fieldValues,
                [name]: value,
                ["scrapAreaNm"]: scrapAreaNm,
            });
            props.setPrimaryParameters({
                ...props.primaryParameters,
                ["schScrapAreaCd"]: value,
            });
        } else {
            props.setFieldValues({
                ...props.fieldValues,
                [name]: value,
            });
        }
    });
    const SEARCH_SCORE_GRADE_URL = "/inspection/video/searchScoreGrade.do";
    const fetchScoreGrade = async () => {

        const rate1 = props.fieldValues.subItemCd1 ? parseInt(props.fieldValues.subItemRate1) || 0 : 0;
        const rate2 = props.fieldValues.subItemCd2 ? parseInt(props.fieldValues.subItemRate2) || 0 : 0;
        const rate3 = props.fieldValues.subItemCd3 ? parseInt(props.fieldValues.subItemRate3) || 0 : 0;

        const total = rate1 + rate2 + rate3;

        if (total === 100) {
            setLoading(true);

            // console.log(props.fieldValues.subItemRate1);
            try {
                const {
                    data: {data},
                } = await fetchData({
                    url: SEARCH_SCORE_GRADE_URL,
                    params: {
                        systemCd : props.fieldValues.systemCd,
                        subItemCd1 : props.fieldValues.subItemCd1,
                        subItemCd2 : props.fieldValues.subItemCd2,
                        subItemCd3 : props.fieldValues.subItemCd3,
                        subItemRate1 : rate1,
                        subItemRate2 : rate2,
                        subItemRate3 : rate3
                    },
                    method: "POST",
                });
                console.log("Fetch result:", data);

                if (data && data.length > 0 && data[0].detlCd) {
                    // If data exists and is valid, set the dcsnItemCd

                    console.log(`${data[0].detlCd} ( 상한(미만):${data[0].detlCd} , 하한(이상):${data[0].minValue} ,스코어:${data[0].maxValue} )`);
                    props.setFieldValues({
                        ...props.fieldValues,
                        dcsnItemCd: data[0].detlCd, // Set dcsnItemCd to the fetched value
                        dcsnItemScoreCd: data[0].detlCd,
                        dcsnDesc: `${data[0].score}`
                    });
                } else {
                    // If no valid data, reset dcsnItemCd
                    props.setFieldValues({
                        ...props.fieldValues,
                        dcsnItemCd: '', // Reset dcsnItemCd to an empty string
                        dcsnItemScoreCd: '', // Reset dcsnItemCd to an empty string
                        dcsnDesc: '', // Reset dcsnItemCd to an empty string
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }else{
            props.setFieldValues({
                ...props.fieldValues,
                dcsnItemCd: '', // Reset dcsnItemCd to an empty string
                dcsnItemScoreCd: '', // Reset dcsnItemCd to an empty string
                dcsnDesc: '', // Reset dcsnItemCd to an empty string
            });
        }
    }

    useEffect(() => {
        props.fieldValues.systemCd = 'DH';
        fetchScoreGrade();
    }, [props.fieldValues.subItemRate1, props.fieldValues.subItemRate2, props.fieldValues.subItemRate3, props.fieldValues.subItemCd1, props.fieldValues.subItemCd2, props.fieldValues.subItemCd3]);

    const onReturnClick = (e) => {
        ModalReturnListPop({
            vhclNo: props.fieldValues.vhclNo,
            odrType: "50",
        });
    };

    return (
        <>
            <div className="table_list on">
                <ul className="t_form">
                    <li className="half">
                        <div className="title2">사전등급</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="TRANS_CD"
                                id="transCd"
                                name="transCd"
                                disabled={true}
                                topSelected="선택"
                                value={props.fieldValues.transCd}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="formbox">
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="itemCd"
                                name="itemCd"
                                disabled={true}
                                topSelected="선택"
                                value={props.fieldValues.itemCd}
                                className="ip2"
                            />
                        </div>
                        <div className="formbox">
                            <input
                                type="button"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "vhclNo",
                                    disabledFields
                                )}
                                className="btn_ip"
                                onClick={props.fieldValues.returnCnt > 0 ? onReturnClick : ""}
                                value="경고/반품"
                                style={
                                    props.fieldValues.returnCnt > 0
                                        ? {background: "#e84444"}
                                        : {}
                                }
                            />
                        </div>
                    </li>
                    <li className="">
                        <div className="title2">차량번호</div>
                        <div className="ip_sup3">
                            <div>
                                <input
                                    type="text"
                                    id="vhclNo"
                                    name="vhclNo"
                                    disabled={true}
                                    value={props.fieldValues.vhclNo}
                                    className="ip2"
                                />
                            </div>
                            <div>
                                <SelectBox
                                    mastCd="VHCL_TYPE"
                                    id="vhclType"
                                    name="vhclType"
                                    topSelected="선택"
                                    disabled={isFieldDisabled(
                                        props.state,
                                        "vhclType",
                                        disabledFields
                                    )}
                                    onChange={handleChangeField}
                                    value={props.fieldValues.vhclType}
                                    className="ip2"
                                />
                            </div>
                            <div>
                                <input
                                    type="button"
                                    className="btn_ip"
                                    onClick={props.handleIncomingClick}
                                    value="입차계근"
                                />
                            </div>
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">공급업체</div>
                        <div className="formbox">
                            <input
                                type="text"
                                id="vndrNm"
                                name="vndrNm"
                                disabled={true}
                                value={props.fieldValues.vndrNm}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">실공급업체</div>
                        <div className="formbox">
                            <input
                                type="text"
                                id="rvndrNm"
                                name="rvndrNm"
                                disabled={true}
                                value={props.fieldValues.rvndrNm}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">하차지</div>
                        <div className="formbox">
                            <div>
                                <SelectBox
                                    mastCd="SCRAP_AREA_CD"
                                    id="scrapAreaCd"
                                    name="scrapAreaCd"
                                    topSelected="선택"
                                    disabled={isFieldDisabled(
                                        props.state,
                                        "scrapAreaCd",
                                        disabledFields
                                    )}
                                    attr1={props.fieldValues.plantCd}
                                    onChange={handleChangeField}
                                    value={props.fieldValues.scrapAreaCd}
                                    className="ip2"
                                />
                            </div>
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">검수원</div>
                        <div className="formbox">
                            <div>
                                <input
                                    type="text"
                                    id="workNm"
                                    name="workNm"
                                    disabled={true}
                                    value={userInfo.nmKor}
                                    className="ip2"
                                />
                            </div>
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">입차일시</div>
                        <div className="formbox">
                            <input
                                type="text"
                                id="wghtDt"
                                name="wghtDt"
                                topSelected="선택"
                                disabled="true"
                                value={props.fieldValues.wghtDt}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">총중량</div>
                        <div className="formbox">
                            <input
                                type="text"
                                id="totalWeight"
                                name="totalWeight"
                                disabled="true"
                                value={props.fieldValues.totalWeight}
                                className="ip2"
                            />
                        </div>
                    </li>

                    <li className="half">
                        <div className="title2">스코어등급</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="dcsnItemScoreCd"
                                name="dcsnItemScoreCd"
                                topSelected="선택"
                                disabled={true}
                                onChange={handleChangeField}
                                value={props.fieldValues.dcsnItemScoreCd}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">스코어</div>
                        <div className="formbox">
                            <input
                                type="text"
                                id="dcsnDescText"
                                name="dcsnDescText"
                                value={props.fieldValues.dcsnDesc}
                                disabled={true}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="">
                        <div className="title2">검수등급</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="dcsnItemCd"
                                name="dcsnItemCd"
                                topSelected="선택"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "dcsnItemCd",
                                    disabledFields
                                )}
                                onChange={handleChangeField}
                                value={props.fieldValues.dcsnItemCd}
                                className="ip2"
                            />
                        </div>
                    </li>
                </ul>
                <table className="t_greyth">
                    <tr>
                        <th>등급</th>
                        <th>품목</th>
                        <th>비율</th>
                    </tr>
                    <tr className="t_slider">
                        <td>
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="subItemCd1"
                                name="subItemCd1"
/*                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemCd1",
                                    disabledFields
                                )}*/
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemCd1}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_PRD_CD"
                                id="subItemPrdCd1"
                                name="subItemPrdCd1"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemPrdCd1",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                attr1={props.fieldValues.subItemCd1}
                                value={props.fieldValues.subItemPrdCd1}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_RATE"
                                id="subItemRate1"
                                name="subItemRate1"
/*                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemRate1",
                                    disabledFields
                                )}*/
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemRate1}
                                className="ip2"
                            />
                        </td>
                    </tr>
                    <tr className="t_slider">
                        <td>
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="subItemCd2"
                                name="subItemCd2"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemCd2",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemCd2}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_PRD_CD"
                                id="subItemPrdCd2"
                                name="subItemPrdCd2"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemPrdCd2",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                attr1={props.fieldValues.subItemCd2}
                                value={props.fieldValues.subItemPrdCd2}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_RATE"
                                id="subItemRate2"
                                name="subItemRate2"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemRate2",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemRate2}
                                className="ip2"
                            />
                        </td>
                    </tr>
                    <tr className="t_slider">
                        <td>
                            <SelectBox
                                mastCd="ITEM_CD"
                                id="subItemCd3"
                                name="subItemCd3"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemCd3",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemCd3}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_PRD_CD"
                                id="subItemPrdCd3"
                                name="subItemPrdCd3"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemPrdCd3",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                attr1={props.fieldValues.subItemCd3}
                                value={props.fieldValues.subItemPrdCd3}
                                className="ip2"
                            />
                        </td>
                        <td>
                            <SelectBox
                                mastCd="ITEM_RATE"
                                id="subItemRate3"
                                name="subItemRate3"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "subItemRate3",
                                    disabledFields
                                )}
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.subItemRate3}
                                className="ip2"
                            />
                        </td>
                    </tr>
                </table>
                <ul className="t_form">
                    <li className="half">
                        <div className="title2">감량</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="OUTAGE_WGHT"
                                id="outageWght"
                                name="outageWght"
                                topSelected="선택"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "outageWght",
                                    disabledFields
                                )}
                                onChange={handleChangeField}
                                value={props.fieldValues.outageWght}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">사유</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="OUTAGE_CD"
                                id="outageRsn"
                                name="outageRsn"
                                topSelected="선택"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "outageRsn",
                                    disabledFields
                                )}
                                onChange={handleChangeField}
                                value={props.fieldValues.outageRsn}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">반품/경고</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="RETURN_CD"
                                id="returnCd"
                                name="returnCd"
                                topSelected="선택"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "returnCd",
                                    disabledFields
                                )}
                                onChange={handleChangeField}
                                value={props.fieldValues.returnCd}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">사유</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="OUTAGE_CD"
                                id="returnRsn"
                                name="returnRsn"
                                topSelected="선택"
                                disabled={isFieldDisabled(
                                    props.state,
                                    "returnRsn",
                                    disabledFields
                                )}
                                onChange={handleChangeField}
                                value={props.fieldValues.returnRsn}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">감가비율</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="ITEM_RATE"
                                id="dprctRate"
                                name="dprctRate"
                                disabled={
                                    props.fieldValues.systemCd === "DH"
                                        ? true
                                        : isFieldDisabled(props.state, "dprctRate", disabledFields)
                                }
                                topSelected="선택"
                                onChange={handleChangeField}
                                value={props.fieldValues.dprctRate}
                                className="ip2"
                            />
                        </div>
                    </li>
                    <li className="half">
                        <div className="title2">감가내역</div>
                        <div className="formbox">
                            <SelectBox
                                mastCd="DPRCT_CD"
                                id="dprctCd"
                                name="dprctCd"
                                topSelected="선택"
                                disabled={
                                    props.fieldValues.systemCd === "DH"
                                        ? true
                                        : isFieldDisabled(props.state, "dprctCd", disabledFields)
                                }
                                onChange={handleChangeField}
                                value={props.fieldValues.dprctCd}
                                className="ip2"
                            />
                        </div>
                    </li>
                </ul>

                <button
                    style={{width: "100%", height: "80px", borderRadius: "10px"}}
                    className="btn_greystyle"
                    onClick={props.handleMasterSave}
                >
                    검수저장
                </button>
            </div>
        </>
    );
};

export default InspectionReg;
